import Button from 'antd/es/button';
import 'antd/lib/button/style';
export default Button;
